import get from "lodash.get";
import { sortByPriorityKey } from "../sortByPriorityKey";
import { getAssetURLMapping, getEntryURLMapping } from "./assets";

export const formatJournals = (data, isWebPSupported) => {
  const allJournalRaw = get(data, "data.items", []);

  const assetMap = getAssetURLMapping(data.data, isWebPSupported);
  const entryMap = getEntryURLMapping(data.data);

  const allJournals = allJournalRaw.map((journal) => {
    const layoutBlocks = get(journal, "fields.layoutBlocks", []).map(
      (entryRef) => {
        const layoutId = get(entryRef, "sys.id");
        const layoutEntry = entryMap[layoutId];

        if (!layoutEntry) return null;

        const fields = layoutEntry.fields || {};

        const image1Entry = entryMap[get(fields, "image1.sys.id")];
        const image1 = assetMap[get(image1Entry, "fields.image.sys.id")];
        const image1Caption = get(image1Entry, "fields.caption", "");
        const image2Entry = entryMap[get(fields, "image2.sys.id")];
        const image2 =
          assetMap[get(image2Entry, "fields.image.sys.id")] || null;
        const image2Caption = get(image2Entry, "fields.caption", "");

        return {
          body: formatCustomTextToHTML(get(fields, "body", "")),
          journalTitle: get(fields, "journalTitle"),
          layoutType: (get(fields, "layoutType") || "").replaceAll(" ", ""),
          image: image1,
          image1Caption,
          image2,
          image2Caption,
        };
      }
    );

    let horizontal;
    let vertical;

    get(journal, "fields.tileImages", []).forEach((link) => {
      const entryId = get(link, "sys.id");
      const entry = entryMap[entryId];
      if (get(entry, "fields.imageOrientation") === "Landscape") {
        horizontal = assetMap[get(entry, "fields.featureImage.sys.id")];
      } else {
        vertical = assetMap[get(entry, "fields.featureImage.sys.id")];
      }
    });

    return {
      date: get(journal, "fields.date"),
      title: get(journal, "fields.journalTitle"),
      tileTitle: get(journal, "fields.tileTitle"),
      slug: get(journal, "fields.slug").toLowerCase(),
      layoutBlocks,
      horizontal,
      vertical,
      priority: get(journal, "fields.priority"),
    };
  });

  const sortedJouranl = sortByPriorityKey(allJournals);

  return sortedJouranl;
};

export const formatCustomTextToHTML = (input) => {
  if (!input || typeof input !== "string") return "";

  const lines = input.split("\n");
  let output = "";

  // Helper to parse headers
  const parseHeader = (line) => {
    if (line.startsWith("### ")) return `<h3>${line.slice(4).trim()}</h3><br>`;
    if (line.startsWith("## ")) return `<h2>${line.slice(3).trim()}</h2><br>`;
    if (line.startsWith("# ")) return `<h1>${line.slice(2).trim()}</h1><br>`;
    return null;
  };

  // Helper to parse bold
  const parseBold = (line) => {
    const boldRegex = /__(.*?)__/;
    const match = line.match(boldRegex);
    if (match) {
      return {
        html: `<p><strong>${match[1].trim()}</strong></p>`,
        lineWithoutBold: line.replace(boldRegex, "").trim(),
      };
    }
    return { html: null, lineWithoutBold: line };
  };

  // Helper to parse italics
  const parseItalics = (line) => {
    const italicRegex = />\s*(.*?)\s*>/g;
    let italicsHTML = "";
    let cleanedLine = line;
    let match;

    while ((match = italicRegex.exec(line)) !== null) {
      italicsHTML += `<p><em>${match[1].trim()}</em></p>`;
    }

    cleanedLine = cleanedLine.replace(italicRegex, "").trim();
    return { italicsHTML, cleanedLine };
  };

  // ⭐ NEW: Helper to parse markdown-style links
  const parseLinks = (line) => {
    const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;

    return line.replace(linkRegex, (match, text, url) => {
      return `<a href="${url}" target="_blank">${text}</a>`;
    });
  };

  for (let rawLine of lines) {
    let line = rawLine.trim();
    if (!line) continue;

    // Parse header first
    const headerHTML = parseHeader(line);
    if (headerHTML) {
      output += headerHTML + "<br>";
      continue;
    }

    // Parse bold
    const { html: boldHTML, lineWithoutBold } = parseBold(line);
    line = lineWithoutBold;

    // Parse italics
    const { italicsHTML, cleanedLine } = parseItalics(line);
    line = cleanedLine;

    // ⭐ Parse links
    line = parseLinks(line);

    // Add bold HTML block if found
    if (boldHTML) output += boldHTML + "<br>";

    // Add italics HTML block(s)
    if (italicsHTML) output += italicsHTML + "<br>";

    // Add any remaining text
    if (line) {
      output += `<p>${line}</p><br>`;
    }
  }

  return output.trim();
};
